export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const SET_USER = "SET_USER";
export const SET_USERS = "SET_USERS";
export const SET_EDITING_USER = "SET_EDITING_USER";
export const SET_AGENCIES = "SET_AGENCIES";
export const UPDATE_ROLES = "UPDATE_ROLES";
export const SET_INSTANCE_ID = "SET_INSTANCE_ID";
